// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3iaKg8Vpb7dVg1_FYvfozqvoPGii7qko",
  authDomain: "springhouse-sandbox.firebaseapp.com",
  projectId: "springhouse-sandbox",
  storageBucket: "springhouse-sandbox.firebasestorage.app",
  messagingSenderId: "63931403265",
  appId: "1:63931403265:web:ab348b871c27851d028400"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Add these exports
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Function to get the current user's ID token.
// Firebase caches the JWT (~1 hour). Pass true only to force a refresh.
export const getAuthToken = async (forceRefresh = false) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('No user logged in');
  }
  return await user.getIdToken(forceRefresh);
};

// Function to make authenticated API requests
export const authenticatedFetch = async (url, options = {}) => {
  try {
    const token = await getAuthToken();
    const headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
    
    const response = await fetch(url, {
      ...options,
      headers,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error making authenticated request:', error);
    throw error;
  }
};